import { FEATURES, useFeature } from '@/features/feature-flags';
import { settingsStore } from '@/stores/settings.store';

export const useFeedComposerEnabled = () => {
  'use no memo';

  const hasFeature = useFeature();
  return hasFeature(FEATURES.FEED_COMPOSER) && settingsStore.feedComposerChats;
};
